import { render, staticRenderFns } from "./AdminAuxillaryStaff.vue?vue&type=template&id=257dda59"
import script from "./AdminAuxillaryStaff.vue?vue&type=script&lang=js"
export * from "./AdminAuxillaryStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports